import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { StoreStateType } from 'common/store'

type InitialStateType = boolean | null

const initialState = true as InitialStateType

export const autoDownloadFilesSlice = createSlice({
  initialState,
  name: 'autoDownloadFiles',
  reducers: {
    setAutoDownloadFiles(state, action: PayloadAction<boolean>) {
      state = action.payload
      return state
    },
  },
})

export const autoDownloadFilesActions = autoDownloadFilesSlice.actions
export const useAutoDownloadFilesActions = () => {
  const dispatch = useDispatch()
  const setAutoDownloadFiles = useCallback(
    (payload: boolean) => {
      return dispatch(autoDownloadFilesActions.setAutoDownloadFiles(payload))
    },
    [dispatch],
  )
  return { setAutoDownloadFiles }
}

const selectAutoDownloadFiles = (state: StoreStateType) =>
  state.autoDownloadFiles

export const useAutoDownloadFiles = () => {
  const { setAutoDownloadFiles } = useAutoDownloadFilesActions()
  const autoDownloadFiles = useSelector(selectAutoDownloadFiles)
  return useMemo(
    () => ({ autoDownloadFiles, setAutoDownloadFiles }),
    [setAutoDownloadFiles, autoDownloadFiles],
  )
}
